module.exports = {"documentTitleSuffix":" - Ledger Explorer"}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./src/config.json
// module id = 472
// module chunks = 0